import React from "react";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";

export default function ShahkarFailed() {
    return (
        <StackKit direction="row" sx={{
            width: "100%",
            justifyContent: "space-between",
            height: "486px",
            marginBottom: "30px",
            padding: "10px 30px",
            alignItems: "center"
        }}>
            <StackKit sx={{width: "100%", height: "100%"}}>
                <StackKit sx={{width: "100%", height: "100%", background: "linear-gradient(97.77deg, rgba(0, 0, 0, 0.4) -9.73%, rgba(23, 23, 23, 0.281106) 16.04%, rgba(115, 103, 240, 0.25) 50.23%, rgba(65, 65, 65, 0.231942) 87.66%, rgba(0, 0, 0, 0.16) 109.42%)",}}>
                    <StackKit sx={{width: "100%", height: "100%",display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <TypoGraphyKit className={'!text-2xl !mb-5 !text-red-500'}>
                            اطلاعات هویتی شما توسط موسسه اعتبار سنجی رد شد
                        </TypoGraphyKit>
                        <TypoGraphyKit>
                            لطفا با پشتیبانی تماس برقرار کنید
                        </TypoGraphyKit>
                    </StackKit>
                </StackKit>
            </StackKit>
        </StackKit>
    )
}